import { useNavigate, useLocation } from "react-router-dom";

const DesktopNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const scrollToSection = (sectionId: string) => {
    if (location.pathname === "/") {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <nav className="desktop-nav">
      <div className="flex items-center justify-between max-w-7xl mx-auto px-16 xl:px-24 py-4">
      <button onClick={() => navigate("/")} className="flex items-center gap-2">
        <img src="/meem-logo-default.webp" alt="Meem" className="h-4 object-contain" />
        <span className="text-xl font-extrabold text-primary mb-1">meem</span>
      </button>
      <div className="flex items-center gap-8">
        <button
          onClick={() => navigate("/")}
          className={`text-sm font-medium transition-colors ${isActive("/") ? "text-primary" : "text-muted-foreground hover:text-foreground"}`}
        >
          Home
        </button>
        <button
          onClick={() => scrollToSection("how-it-works")}
          className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
        >
          How It Works
        </button>

        <button
          onClick={() => scrollToSection("track-order")}
          className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
        >
          Track Order
        </button>
        <button
          onClick={() => navigate("/choose-type")}
          className="btn-primary !py-2.5 !px-6 !text-sm !rounded-xl"
        >
          Order Now
        </button>
      </div>
      </div>
    </nav>
  );
};

export default DesktopNav;
